module.exports = __webpack_public_path__ + "img/hamburger-menu.svg";